import { render, staticRenderFns } from "./MetaboliteAddBatch.vue?vue&type=template&id=18fb1e09&"
import script from "./MetaboliteAddBatch.vue?vue&type=script&lang=js&"
export * from "./MetaboliteAddBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports